import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { ElementRef, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { MomService } from 'src/app/service/mom.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { environment_const, environment_msg } from 'src/environments/environment';
import { NotifierService } from 'angular-notifier';
import { Globals } from 'src/app/service/global';
interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-partic-review-select-dialog',
  templateUrl: './partic-review-select-dialog.component.html',
  styleUrls: ['./partic-review-select-dialog.component.css']
})
export class ParticReviewSelectDialogComponent implements OnInit {
  minuteJSON: any;
  //agendaArray:any = [];
  momList:any =[];
  curMomStatus:any;
  selectedValue: any="select";
  constructor(private utilityService:UtilityService,private permissionService:PermissionService,private notifierService: NotifierService,private globals:Globals,private sideNav : SideNavServiceService,private matDialogRef:MatDialogRef<ParticReviewSelectDialogComponent>,private momService:MomService,@Inject(MAT_DIALOG_DATA) public data: {title: string,meetingResp:any,curPkMoMDetailId:any,momList:any,reviewType:any}) { 
    
    
  }
  particToggler = true
  
  toppingsControl = new UntypedFormControl([Validators.required]);
  //toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemoved(topping: string) {
    
    const toppings = this.toppingsControl.value as string[];
    this.removeFirst(toppings, topping);
     // To trigger change detection
    
  }

  callTrigger(){
    
    this.toppingsControl.setValue(this.toppingsControl.value);
 

  }
  
  getSelectedParticipants(){
    var attendeeIds = "";
    
    if(this.toppingsControl.value!=null){
      this.toppingsControl.value.forEach((element:any) => {
        attendeeIds+=element.fkSecUserAttendee+",";
      });
      if(attendeeIds!=null && attendeeIds.endsWith(",")){
        attendeeIds=attendeeIds.slice(0,attendeeIds.length-1);
      }
    }
 
    return attendeeIds;
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  hideAddParticipants(){
    this.particToggler = false
  }

  showAddParticipants(){
    this.particToggler = true
  }

  ngOnInit(){
    this.momList=this.data.momList;
    this.selectedValue=this.data.curPkMoMDetailId;
    this.getCurrentMomStatus();
 
    if(this.curMomStatus!=undefined && this.curMomStatus!=environment_const.momApproveStatus){
      this.selectedValue=this.data.curPkMoMDetailId;
    }else{
      this.selectedValue="select";
    }
  }
  getCurrentMomStatus(){
    if(this.momList!=null && this.momList.length>0){
      var curMomInfo = this.momList.filter((obj:any) => obj.pkMomDetailId == this.selectedValue);
 
      if(curMomInfo!=null && curMomInfo.length>0  && curMomInfo[0].momStatusCode!=undefined && curMomInfo[0].momStatusCode!=null){
        this.curMomStatus=curMomInfo[0].momStatusCode;
      }
    }
  }
  
  sendDraft(){

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MINUTES,this.utilityService.permissionType.MODIFY);
    
    if(!roleFlag){
      return;
    }
    if(this.selectedValue!=undefined && this.selectedValue!=null && this.selectedValue!="select"){
      //this.agendaArray = [];
      // this.data.meetingResp.agendaList.forEach((ele:any) => {
      //   let tempJSON = {agendaId:""};
      //   tempJSON.agendaId = ele.agendaId;
      //   this.agendaArray.push(tempJSON);
      // });
      var reviewType = "";
      var momStatus = "";
      var reviewSendTo = ""
      var seletedParticipants = (<HTMLInputElement>document.getElementById('participants'))
      
      if(seletedParticipants.checked == true){
        reviewType = 'RS';
        momStatus = 'Com';
        reviewSendTo = this.getSelectedParticipants();
      }else{
        reviewType = 'RA';
        momStatus = 'Com';
        reviewSendTo = "";
      }

      if(this.data.reviewType != null && this.data.reviewType != undefined && this.data.reviewType == "APPROVE"){
        //reviewType = this.data.reviewType;
        momStatus = "A";
      }

      if(((reviewSendTo == undefined || reviewSendTo == "undefined" || reviewSendTo == "") && reviewType == "RS") || (reviewType == "APPROVE" && seletedParticipants.checked == true && (reviewSendTo == "undefined" || reviewSendTo == ""))){
        this.sideNav.alertSelectParticipantsSendMom('participants')
      }else{
      
        this.minuteJSON = {
        //  "agendaDetails": "previewAgendaArray:"+JSON.stringify(this.agendaArray),
        //  "approvalHours": this.data.meetingResp.approvalHours,
        //  "deletedFlag": 0,
        //  "meetingEndFlag": this.data.meetingResp.meetingEndFlag,
          "meetingId": this.data.meetingResp.meetingId,
          "fkMeetingEntityId": this.data.meetingResp.meetingId,
          "previewFlag": "N",
          "pkMomDetailId":this.selectedValue,
          "reviewType": reviewType,
          "orgCode": this.data.meetingResp.orgCode,
          "momStatusCode":momStatus,
          "visitorTimeZone":this.globals.vTimeZone,
          "userId":localStorage.getItem("userId"),
          "minTemplateId": this.data.meetingResp.minTemplateId,
          "decryptKey": this.data.meetingResp.isConfidential == 'Y'?localStorage.getItem("decryptKey"):"",

        };
        //this.minuteJSON.sendDraft="Y";
        this.minuteJSON.reviewSendTo=reviewSendTo;
        
        this.momService.previewMinutes(this.minuteJSON).subscribe((response)=>{
          
          if(this.data.reviewType != null && this.data.reviewType != undefined && this.data.reviewType == "APPROVE"){
            this.sideNav.alertMeetingApprove('momApprove');
            this.matDialogRef.close(this.minuteJSON);
          }else{
            this.sideNav.alertSentMeetingDraft('momDraft');
            this.matDialogRef.close();
          }
        });
        reviewSendTo = "";
      }
    }else{
      this.notifierService.show({
        type: 'error',
        message: environment_msg.msg_error_select_mom
      });
     
    }
  }


}
